import React, { useEffect, useState } from "react";
import axios from "axios";

export default function DeviceStatus() {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    fetchDevices();
    const interval = setInterval(fetchDevices, 60000); // refresh every 1 min
    return () => clearInterval(interval);
  }, []);

  const fetchDevices = async () => {
    try {
      const res = await axios.get("/api/devices");
      setDevices(res.data);
    } catch (err) {
      console.error("Failed to fetch devices:", err);
    }
  };

  const getStatus = (lastSeen) => {
    if (!lastSeen) return "Offline";

    const last = new Date(lastSeen);
    const now = new Date();
    const diffMinutes = (now - last) / 1000 / 60;
    return diffMinutes < 10 ? "Online" : "Offline"; // <2 min = online
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Device Status</h2>
      <table className="min-w-full border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="px-4 py-2 text-left">Device Name</th>
            <th className="px-4 py-2 text-left">IP Address</th>
            <th className="px-4 py-2 text-left">Last Seen</th>
            <th className="px-4 py-2 text-left">Last Run Time</th>
            <th className="px-4 py-2 text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          {devices.map((device, idx) => {
            const status = getStatus(device.lastseen);
            const color =
              status === "Online" ? "text-green-600" : "text-red-600";

            return (
              <tr key={idx} className="border-t">
                <td className="px-4 py-2">{device.device_name}</td>
                <td className="px-4 py-2">{device.ip_addr}</td>
                <td className="px-4 py-2">
                  {new Date(device.lastseen).toLocaleString()}
                </td>
                <td className="px-4 py-2">
                  {new Date(device.lastruntime).toLocaleString()}
                </td>
                <td className={`px-4 py-2 font-bold ${color}`}>{status}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
